import axios from 'axios'
import {logger} from '@plugins/logger'
import {getApiUrl} from '@utils/api-helpers'
import {capitalize} from '@utils/string-helpers'

const endpoint = {
  email: 'https://eu-ws.informaticadaas.com/EmailVerify7/EmailVerification/VerifyEmail',
  phone: 'https://eu-ws.informaticadaas.com/GlobalPhoneVal20/GlobalPhoneValidation20/ValidateNumberCountry',
  address: 'https://eu-av.informaticadaas.com/AV6/v1/process'
}
const VALIDATIONS_ENABLED = ['email', 'phone']

export default {
  namespaced: true,
  //
  // State
  state: {
    optionsLoaded: false,
    settings: {
      email: false,
      phone: false,
      address: false
    },
    addressUserId: null,
    addressUserPassword: null,
    emailUserId: null,
    emailUserPassword: null,
    phoneUserId: null,
    phoneUserPassword: null
  },
  //
  // Getters
  getters: {
    validationsEnabled: () => VALIDATIONS_ENABLED
  },
  //
  // Mutations
  mutations: {
    'UPDATE_SETTINGS'(state, response) {
      if (response.email) {
        state.settings.email = true
      }
      if (response.phone) {
        state.settings.phone = true
      }
      if (response.address) {
        state.settings.address = true
      }
      if (response.addressUserId) {
        state.addressUserId = response.addressUserId
      }
      if (response.addressUserPassword) {
        state.addressUserPassword = response.addressUserPassword
      }
      if (response.emailUserId) {
        state.emailUserId = response.emailUserId
      }
      if (response.emailUserPassword) {
        state.emailUserPassword = response.emailUserPassword
      }
      if (response.phoneUserId) {
        state.phoneUserId = response.phoneUserId
      }
      if (response.phoneUserPassword) {
        state.phoneUserPassword = response.phoneUserPassword
      }
      state.optionsLoaded = true
    }
  },
  //
  // Actions
  actions: {
    async getValidationSettings({ state, commit, rootState }) {
      try {
        if (!state.optionsLoaded) {
          const { data } = await axios.get(
            getApiUrl('/api/v1/profile/external-validations')
          )
          commit('UPDATE_SETTINGS', data)
        }
        return true
      } catch (err) {
        logger.error(err)
      }
    },
    async getDefaultParams({ state }, { params, validationType }) {
      params.append('Format', 'JSON')
      params.append('LicenseInfo.RegisteredUser.UserID', state[`${validationType}UserId`])
      if (state.userPassword) {
        params.append('LicenseInfo.RegisteredUser.Password', state[`${validationType}UserPassword`])
      }
    },
    async validateEmail({ state, dispatch }, emails) {
      try {
        const params = new URLSearchParams()
        await dispatch('getDefaultParams', { params, validationType: 'email' })
        params.append('VerifyEmail.Email', emails[0])
        params.append('VerifyEmail.TimeoutSeconds', 5)
        const { data } = await axios.post(
          endpoint.email,
          params,
          { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
        )
        const status = data?.WebServiceResponse?.VerifyEmailResponse?.VerifyEmailResult?.ServiceStatus?.StatusNbr ?? '0' // 0 will be invalid resonse
        const message = data?.WebServiceResponse?.VerifyEmailResponse?.VerifyEmailResult?.ServiceStatus?.StatusDescription
        if (status === '0') {
          logger.error('Email Validation Invalid Response: ', data)
        }
        return { isValid: Number(status) < 300, message, status }
      } catch(err) {
        logger.error(err)
        throw err
      }
    },
    async validatePhone({ state, dispatch }, phone) {
      try {
        const params = new URLSearchParams()
        await dispatch('getDefaultParams', { params, validationType: 'phone' })
        params.append('ValidateNumberCountry.Country', phone[0])
        params.append('ValidateNumberCountry.Number', phone[1])
        const { data } = await axios.post(
          endpoint.phone,
          params,
          { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
        )
        const status = data?.WebServiceResponse?.ValidateNumberCountryResponse?.ValidateNumberCountryResult?.ServiceStatus?.StatusNbr ?? '0' // 0 will be invalid resonse
        const message = data?.WebServiceResponse?.ValidateNumberCountryResponse?.ValidateNumberCountryResult?.ServiceStatus?.StatusDescription
        const numberType = data?.WebServiceResponse?.ValidateNumberCountryResponse?.ValidateNumberCountryResult?.ServiceResult?.Listing?.Number_Type
        if (status === '0') {
          logger.error('Phone Validation Invalid Response: ', data)
        }
        return { isValid: Number(status) < 300, message, status, numberType }
      } catch(err) {
        logger.error(err)
        throw err
      }
    },
    async validate({ dispatch, getters, state }, { validationType, value }) {
      if (!getters.validationsEnabled.includes(validationType)) {
        logger.debug('External validation not enabled: ', validationType)
        return { isValid: true, message: 'Success', status: '200' }
      }
      if (!state.optionsLoaded) {
        await dispatch('getValidationSettings')
      }
      if (!state.settings[validationType]) {
        return { isValid: true, message: 'Success', status: '200' }
      }
      try {
        const response = await dispatch(`validate${capitalize(validationType)}`, value)
        if (!response.isValid) {
          return response
        }
      } catch (err) {
        logger.debug('Validate Error: ', err)
      }
      return { isValid: true, message: 'Success', status: '200' }
    }
  }
}
